<template>
  <div id="prenatal-view">
    <head>
  <meta
    name="description"
    content="Consent for lactation support via in-person or virtual visits, covering assessments, follow-ups, and communications, with privacy protected under HIPAA"
  />
  </head>
    <section class="bg-terms ftco-section">
      <div class="container">
        <h1 class="text-center py-4">{{ title }}</h1>
        <div class="row d-flex align-items-center">
          <div class="col d-flex justify-content-end">
            <p>Version Date: {{ versionDate }}</p>
          </div>
        </div>

        <!-- Consent text displayed in the template -->
        <div>
          <p v-for="(paragraph, index) in consentParagraphs" :key="index">
            {{ paragraph }}
          </p>
        </div>

        <!-- Input fields for name and date on the same line -->
        <p>Please sign below include full name and date</p>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="name">Full Name:</label>
            <input
              type="text"
              id="name"
              v-model="name"
              class="form-control"
              required
            />
          </div>
          <div class="form-group col-md-6">
            <label for="date">Date:</label>
            <input
              type="date"
              id="date"
              v-model="date"
              class="form-control"
              required
            />
          </div>
        </div>
        <!-- Submit button -->
        <button type="button" class="btn btn-primary" @click="submitConsent">
          Submit Consent
        </button>

        <!-- Existing images -->
        <div class="d-flex justify-content-end">
          <img src="@/assets/site/images/fda.webp" alt="" class="img-fluid mx-3" />
          <img src="@/assets/site/images/gold.webp" alt="" class="img-fluid" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import emailjs from 'emailjs-com';

export default {
  name: "PrenatalView",
  data() {
    return {
      name: '',
      date: '',
      title: 'Lactation Consult and Support Consent',
      versionDate: 'October 26, 2024',
      consentParagraphs: [
        `I give my consent for the lactation consultant to work with me and/or me and my baby during
        and/or while preparing for breastfeeding. This consent covers all visits and communication including telehealth visits,
        support groups visits as well as phone conversations, and any information communicated by e-mail,
        mobile phone, fax, SMS text messages, and or email.`,
        `I understand that electronic/cellular forms of communication may not be encrypted/secure.`,
        `I understand that the lactation education visit may involve viewing my breasts,
        body, and/or nipples for the purposes of assessment for patient educational purposes.
        The support group may also involve viewing of my baby’s latch while at the breast and education regarding the latch may be provided.
        I understand that the education session or support group may involve observation of a breastfeed, pumping, and suggestions,
        education to enhance latch or position, demonstration of the use of pump, equipment or supplies that may be recommended,
        and demonstration of techniques that can improve breastfeeding.`,
        `I understand that I am responsible for informing the lactation consultant of changes I feel are necessary in the plan at the time of the
        telehealth education visit, call, support group or during follow-up communications.
        Contact during the time following the lactation visit is considered an extension of your visit.
        Please email to report progress or to communicate concerns. <a href="mailto:jdresel@calmedhawaii.com" target="_blank">jdresel@calmedhawaii.com</a>`,
        `I give my consent for the lactation consultant to release any information acquired in the evaluation and/or
        management of myself and/or my child to our health care providers, referring physician,
        referring lay breastfeeding counselor, and/or our insurance company upon request.
        I understand the lactation consultant may contact my physician or my child’s physician if the lactation consultant feels it is necessary to consult with the physician.
        I give my consent for the lactation consultant to use clinical information obtained during our sessions for conferring other health care providers and education of mothers about lactation.
        I won’t be identified in any way, but aspects of my situation may be described and discussed.`,
        `I understand that for this lactation consultation and all follow-ups, the lactation consultant will protect the privacy of my personal
        health information as required by the Code of Ethics of the International Board of Lactation Consultant Examiners,
        the Standards of Practice of the International Lactation Consultant Association,
        and the Health Insurance Portability and Accountability Act of 1996 (HIPAA).`,
        `I have chosen to receive care through educational and supportive virtual visit.
        I understand that a Virtual Visit enables health care providers at different locations to provide effective and convenient care by use of technology.
        As with any health care service, I understand there are risks associated with the use of virtual visits, including equipment failure,
        poor audio connection, and information security issues. I understand that through a virtual visit and education session a physical examination and assessment cannot be done,
        this is not a post-partum lactation consult for breastfeeding issues and concerns. I understand the need to go to a clinic for a complete the assessment.
        I understand the risks, and alternatives of virtual visits. I understand this visit is an educational visit for basic breastfeeding information.`,
      ],
    };
  },
  methods: {
    submitConsent() {
      if (!this.name || !this.date) {
        alert('Please fill in both your full name and the date.');
        return;
      }

      // Prepare the email content by sending individual fields
      const templateParams = {
        to_email: 'info@calmedhawaii.com',
        from_name: this.name,
        title: this.title,
        version_date: this.versionDate,
        p1: this.consentParagraphs[0],
        p2: this.consentParagraphs[1],
        p3: this.consentParagraphs[2],
        p4: this.consentParagraphs[3],
        p5: this.consentParagraphs[4],
        p6: this.consentParagraphs[5],
        p7: this.consentParagraphs[6],
        signer_name: this.name,
        signer_date: this.date,
      };

      // EmailJS parameters
      const serviceID = 'service_vxnqmqw';
      const templateID = 'template_0pi8i33';
      const userID = 'biock06jbLypGA2mP';

      emailjs.send(serviceID, templateID, templateParams, userID)
        .then((response) => {
          console.log('SUCCESS!', response.status, response.text);
          // Reset the form
          this.name = '';
          this.date = '';
          // Redirect to /mahalo
          this.$router.push('/mahalo');
        }, (error) => {
          console.log('FAILED...', error);
          alert('There was an error submitting the consent form.');
        });
    },
  },
};
</script>

<style scoped>
#prenatal-view p {
  text-align: justify !important;
}
.form-group {
  margin-bottom: 15px;
}
.btn-primary {
  margin-top: 20px;
}
/* Adjust the layout for the form-row */
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-group {
  padding-right: 5px;
  padding-left: 5px;
}
</style>
